export class EnaioWorkflowMaskPageDefinition {
    id = "";
    name = "";
    number = 0;
    iconId = 0;
}
